"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionCommodityModelSchema = void 0;
var zod_1 = require("zod");
exports.TransactionCommodityModelSchema = zod_1.z.object({
    commodity: zod_1.z.string(),
    quantity: zod_1.z.number(),
});
